import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import PhoneWithPrefix from "shared/components/Input/PhoneWithPrefix";
import { NAME_SPACES } from "shared/locales/constants";
import { ACORIS_PHONE_PREFIXES, CONTACT_POINT_SYSTEM } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import contactAdvisorValidation from "./validation";

function View({ contact, telecoms, onSubmit, onBack, initialMemberNumber }) {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const TRANSLATION = t("CONTACT_ADVISOR", { returnObjects: true });
  const { t: tErrors } = useTranslation();

  const { submitForm, values, setFieldValue, validateField, ...formProps } =
    useFormik({
      initialValues: {
        lastname: get(contact, "user.lastname") || "",
        firstname: get(contact, "user.firstname") || "",
        phonePrefix:
          get(telecoms, `${CONTACT_POINT_SYSTEM.PHONE_NUMBER_PREFIX}.value`) ||
          ACORIS_PHONE_PREFIXES[0].value,
        phone: get(telecoms, `${CONTACT_POINT_SYSTEM.PHONE}.value`) || "",
        email: get(telecoms, `${CONTACT_POINT_SYSTEM.EMAIL}.value`) || "",
        memberNumber: initialMemberNumber || "",
        acceptEmailSms: false,
        acceptPhone: false,
      },
      onSubmit,
      validationSchema: contactAdvisorValidation(
        tErrors(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
      ),
    });

  const isSubmitDisabled =
    !values.lastname ||
    !values.firstname ||
    !values.email ||
    !values.memberNumber ||
    !isEmpty(formProps.errors);

  return (
    <Layout>
      <Header
        title={TRANSLATION.HEADER.TITLE}
        highlight={TRANSLATION.HEADER.HIGHLIGHT}
        subtitle={TRANSLATION.HEADER.SUBTITLE}
      />
      <div className="acoris-form">
        <div className="acoris-form__container">
          <div className="acoris-form__row">
            <Input
              label={TRANSLATION.FORM.LASTNAME.LABEL}
              placeholder={TRANSLATION.FORM.LASTNAME.PLACEHOLDER}
              {...bindInputProps({
                name: "lastname",
                values,
                ...formProps,
              })}
            />
            <Input
              label={TRANSLATION.FORM.FIRSTNAME.LABEL}
              placeholder={TRANSLATION.FORM.FIRSTNAME.PLACEHOLDER}
              {...bindInputProps({
                name: "firstname",
                values,
                ...formProps,
              })}
            />
          </div>
          <div className="acoris-form__row">
            <PhoneWithPrefix
              label={TRANSLATION.FORM.PHONE.LABEL}
              placeholder={TRANSLATION.FORM.PHONE.PLACEHOLDER}
              optional={TRANSLATION.FORM.PHONE.OPTIONAL}
              prefixOptions={ACORIS_PHONE_PREFIXES}
              prefixValue={values.phonePrefix}
              value={values.phone}
              errors={get(formProps, "errors.phone")}
              touched={get(formProps, "touched.phone")}
              onBlur={() => formProps.setFieldTouched("phone", true)}
              onChange={(localNumber) => setFieldValue("phone", localNumber)}
              onPrefixChange={(prefix) => {
                setFieldValue("phonePrefix", prefix);
                validateField("phone");
              }}
            />
            <Input
              type="email"
              label={TRANSLATION.FORM.EMAIL.LABEL}
              placeholder={TRANSLATION.FORM.EMAIL.PLACEHOLDER}
              {...bindInputProps({
                name: "email",
                values,
                ...formProps,
              })}
            />
          </div>
          <div className="acoris-form__row acoris-form__row--single">
            <Input
              label={TRANSLATION.FORM.MEMBER_NUMBER.LABEL}
              placeholder={TRANSLATION.FORM.MEMBER_NUMBER.PLACEHOLDER}
              {...bindInputProps({
                name: "memberNumber",
                values,
                ...formProps,
              })}
            />
          </div>

          <div className="acoris-form__consents">
            <Input
              type="checkbox"
              variant="round"
              checked={values.acceptEmailSms}
              onChange={(checked) => setFieldValue("acceptEmailSms", checked)}
            >
              {TRANSLATION.CONSENT.EMAIL_SMS}
            </Input>
            <Input
              type="checkbox"
              variant="round"
              checked={values.acceptPhone}
              onChange={(checked) => setFieldValue("acceptPhone", checked)}
            >
              {TRANSLATION.CONSENT.PHONE}
            </Input>
          </div>

          <ActionButtons
            disabled={isSubmitDisabled}
            onNext={submitForm}
            onBack={onBack}
            nextText={TRANSLATION.BUTTON.SUBMIT}
            backText={TRANSLATION.BUTTON.BACK}
          />
        </div>
      </div>
    </Layout>
  );
}

export default View;
